import { Component } from '@angular/core';
import { Validators } from '@angular/forms';
import { FormControl, FormGroup } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ModalsComponent } from '../modals.component';

@Component({
  selector: 'app-request-receipt',
  templateUrl: './request-receipt.component.html',
  styleUrls: ['./request-receipt.component.css']
})
export class RequestReceiptComponent extends ModalsComponent {
  defaults:{
    CorpNum?:number,
    CorpName?:string,
    CEOName?:string,
    ContactName?:string,
    Addr?:string,
    Email?:string, 
    PayerName?:string,
  } = {}
  public form : FormGroup;
  public CorpNum:FormControl;				
  public CorpName:FormControl;				
  public CEOName:FormControl;					
  public ContactName:FormControl;					
  public Addr:FormControl;				
  public Email:FormControl;			
  public PayerName:FormControl;					


  constructor(
    modalRef: BsModalRef,
  ) { 
    super(modalRef);
  }
  private createFormControls () {
    this.CorpNum = new FormControl(this.defaults.CorpNum, [Validators.required]);
    this.CorpName = new FormControl(this.defaults.CorpName, [Validators.required]);
    this.CEOName = new FormControl(this.defaults.CEOName, [Validators.required]);
    this.ContactName = new FormControl(this.defaults.ContactName, [Validators.required]);
    this.Addr = new FormControl(this.defaults.Addr, [Validators.required]);
    this.Email = new FormControl(this.defaults.Email, [Validators.required]);
    this.PayerName = new FormControl(this.defaults.PayerName, Validators.required);

  }
  private createForm() { 
    this.form = new FormGroup({
      CorpNum:this.CorpNum,				
      CorpName:this.CorpName,			
      CEOName:this.CEOName,				
      ContactName:this.ContactName,		
      Addr:this.Addr, 
      Email:this.Email,
      PayerName:this.PayerName,
    });
  }
  ngOnInit(): void {
    this.createFormControls();
    this.createForm();
  }
}
